function initTheme(scope=document){
 const mobile=()=>window.matchMedia('(max-width: 800px)').matches;
 const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 scope.querySelectorAll('[data-gallery]').forEach(gallery=>{
  if(gallery.dataset.ready)return;gallery.dataset.ready='true';
  const counter=gallery.parentElement.querySelector('[data-gallery-count]');
  if(!counter)return;
  let ticking=false;
  gallery.addEventListener('scroll',()=>{
   if(ticking)return;ticking=true;
   requestAnimationFrame(()=>{
    const first=gallery.querySelector('figure');
    if(first){const step=first.offsetWidth+parseFloat(getComputedStyle(gallery).columnGap||0);counter.textContent=String(Math.min(gallery.children.length,Math.round(gallery.scrollLeft/step)+1));}
    ticking=false;
   });
  },{passive:true});
 });
 scope.querySelectorAll('[data-product-form]').forEach(form=>{
  if(form.dataset.ready)return;form.dataset.ready='true';
  const select=form.querySelector('[name="id"]');
  if(!select)return;
  select.addEventListener('change',()=>{
   const option=select.selectedOptions[0];
   const region=form.closest('[data-product]');
   region.querySelector('[data-price]').textContent=option.dataset.price;
   const compare=region.querySelector('[data-compare]');
   compare.textContent=option.dataset.compare||'';
   compare.hidden=!option.dataset.compare;
   const button=form.querySelector('[type="submit"]');
   button.disabled=option.disabled;button.textContent=option.disabled?'Sold out':'Add to bag';
   const url=new URL(window.location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
   if(option.dataset.media){
    const media=document.getElementById(option.dataset.media);
    if(media){
     const behavior=reduced()?'auto':'smooth';
     const gallery=media.closest('[data-gallery]');
     if(mobile()&&gallery){gallery.scrollTo({left:media.offsetLeft-(gallery.clientWidth-media.offsetWidth)/2,behavior});}
     else{media.scrollIntoView({block:'nearest',behavior});}
    }
   }
  });
 });
 scope.querySelectorAll('[data-option-pickers]').forEach(pickers=>{
  if(pickers.dataset.ready)return;pickers.dataset.ready='true';
  const form=pickers.closest('form');
  const select=form&&form.querySelector('[name="id"]');
  const json=form&&form.querySelector('[data-variants]');
  if(!select||!json)return;
  let variants;try{variants=JSON.parse(json.textContent);}catch(e){return;}
  const fields=[...pickers.querySelectorAll('select[data-option-index]')];
  const button=form.querySelector('[type="submit"]');
  pickers.hidden=false;
  const fallback=form.querySelector('[data-variant-picker]');if(fallback)fallback.hidden=true;
  const update=changed=>{
   const chosen=fields.map(field=>field.value);
   let match=variants.find(variant=>variant.options.every((value,i)=>value===chosen[i]));
   if(!match){
    const idx=Number(changed.dataset.optionIndex);
    const options=variants.filter(variant=>variant.options[idx]===changed.value);
    match=options.find(variant=>variant.available)||options[0];
    if(match)fields.forEach((field,i)=>{field.value=match.options[i];});
   }
   if(!match){button.disabled=true;button.textContent='Unavailable';return;}
   select.value=String(match.id);
   select.dispatchEvent(new Event('change'));
  };
  fields.forEach(field=>field.addEventListener('change',()=>update(field)));
 });
 scope.querySelectorAll('[data-sound-toggle]').forEach(button=>{
  if(button.dataset.ready)return;button.dataset.ready='true';
  const video=button.closest('.film').querySelector('video');if(!video)return;
  button.addEventListener('click',()=>{video.muted=!video.muted;button.textContent=video.muted?'Turn sound on':'Mute sound';button.setAttribute('aria-pressed',String(!video.muted));});
 });
 if(reduced()){scope.querySelectorAll('video[autoplay]').forEach(video=>{video.autoplay=false;video.pause();});}
}
initTheme();document.addEventListener('shopify:section:load',event=>initTheme(event.target));
